export const styles = {
  infoBoxContainer: {
    width: "100%",
    color: "events.dialogHeaderBackground",
  },
  disclaimer: {
    color: "events.lightBlack",
    marginTop: "8px",
  },
  infoBoxList: {
    paddingTop: "25px",
    position: "unset",
    "& img": {
      width: "40px",
      height: "40px",
    },
  },
  infoBoxListItem: {
    position: "unset",
    padding: "0px",
    paddingBottom: "15px",
  },
  infoBoxListItemText: {
    fontSize: "typography.h4.fontSize",
  },
};
